import BaseService from '../baseService'

export class LoanGroupService extends BaseService {
  approveLoanGroup(id) {
    return this.client.patch(`loan-groups/${id}/approve`).json()
  }
}
